import React, { useEffect, useState } from 'react';

import ComboBox from '../../../../../components/ComboBox';
import CollapsableSection from '../../../../../components/CollapsibleSection';
import ButtonForm from '../../../../../components/ButtonForm';
import InputForm from '../../../../../components/InputForm';
import SelectableList from '../../../../../components/SelectableList';
import SelectionForm from '../../../../../components/SelectionForm';

import CheckIco from '../../../../../components/icons/CheckIco';
import TrashIco from '../../../../../components/icons/TrashIco';
import AddIco from '../../../../../components/icons/AddIco';

import Spinner from '../../../../../components/Spinner';
import { useAuth } from '../../../../../providers/AuthContext';
import { useAppContext } from '../../../../../providers/AppContext';
import { useNavigate } from 'react-router-dom';
import { useWidgets } from '../../../../../providers/WidgetContext';
import { useDashboards } from '../../../../../providers/DashboardContext';
import { createWidget, getWidgetById, updateWidget } from '../../../../../services/apiWidgests';
import { getAllParameters } from '../../../../../services/apiProcessParameteres';
import { translateDatePicker } from '../../../../utils';
import { useProcesses } from '../../../../../providers/ProcessesContext';
import Toggle from '../../../../../components/forms/Toggle';
import DropdownSelectableList from '../../../../../components/icons/DropdownSelectableList';

const ColumnField = ({ header , onDelete=() =>{}}) => {
  return (
    <div className='flex justify-between items-center w-full mr-3'>
      <div className='flex basis-1/3 items-center gap-1'>
        <span>{header.alias || header.key}</span>
      </div>
      <span className='basis-1/3 text-gray-400'>{header.key}</span>
     <button
        onClick={(e) => {
          
          onDelete(header);
        }}
      >
        <TrashIco fill='red' />
      </button>
    </div>
  );
};

const ColumnRowField = ({ header , onDelete=() =>{}}) => {
  return (
    <div className='flex justify-between items-center w-full mr-3'>
      <div className='flex basis-1/3 items-center gap-1'>
        <span>{header.alias || header.key}</span>
      </div>
      <span className='basis-1/3 text-gray-400'>{header.key}</span>
     <button
        onClick={(e) => {
          e.stopPropagation(); // <-- evita que abra el colapsable
          onDelete?.();
        }}
      >
        <TrashIco fill='red' />
      </button>
    </div>
  );
};


const ComplexColumnField = ({ header , onDelete=() =>{}}) => {
  // Extraer datos del target
  const aliasOrKey = header?.target?.alias || header?.target?.key || "Sin nombre";
  const key = header?.target?.key || "";
  
  // Extraer datos del where
  const whereField = header?.where ? Object.keys(header.where)[0] : null;
  const whereCondition = whereField ? header.where[whereField] : null;
  const operator = whereCondition ? Object.keys(whereCondition)[0] : null;
  const value = whereCondition ? whereCondition[operator] : null;

  // Traducir operador para mostrar de forma legible
  const operatorSymbol =
    operator === "equal" ? "=" :
    operator === "notEqual" ? "≠" :
    operator === "greater" ? ">" :
    operator === "less" ? "<" :
    operator || "";

  return (
    <div className="flex justify-between items-center w-full mr-3 border rounded-md p-2 bg-gray-50 hover:bg-gray-100 transition">
      {/* Alias o Key */}
      <div className="flex basis-1/3 items-center gap-1 text-gray-800 font-medium">
        <span>{aliasOrKey}</span>
      </div>

      {/* Where condition */}
      <div className="basis-1/3 text-sm text-gray-500 truncate">
        {whereField && operator && value
          ? `${whereField} ${operatorSymbol} ${value}`
          : "—"}
      </div>

      {/* Key + eliminar */}
      <div className="flex items-center gap-2 basis-1/3 justify-end">
        <span className="text-gray-400 text-xs">{key}</span>
        <button
          className="p-1 hover:bg-red-50 rounded-full"
          onClick={() => onDelete(header)}
        >
          <TrashIco fill="red" className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

function PlanningTableForm({onSubmit = () => {}, id}) {
  const {auth} = useAuth();
  const {addToast} = useAppContext();
  const navigate = useNavigate();
  
  const { addCard, assignSpace } = useWidgets();
  const { dashboard , selectedTab} = useDashboards();
  
  const [processList, setProcessList] = useState([]);
  const [selectedProcess, setSelectedProcess] = useState();
  const [parameters, setParameters] = useState();
  const {menuItems} = useProcesses();
  const [dataRange, setDataRange] = useState('Asignar por dashboard');
  const [title, setTitle] = useState('');
  const [validate, setValidate] = useState(false);
  const [conf, setConf] = useState();
  const [isRate, setIsRate] = useState(false);
  const [toCompare, setToCompare] = useState();
  const [valueToCompare, setValueToCompare] = useState();
  const [aggregation, setAggregation] = useState("add");
  const [timespan, setTimespan] = useState("hours");
  const [interval, setInterval] = useState(1);
  const [stage,setStage] = useState("form");

  const aggregationOptions = {
    "add": "Suma",
    "mean": "Promedio",
    "max": "Máximo",
    "min": "Mínimo",
    "count": "Conteo"
  }
  const timeOptions = {
    "minutes": "Minutos",
    "hours": "Horas",
    "days": "Días",
    "weaks": "Semanas",
    "months": "Meses"
  }
  const OPERATOR_OPTIONS = [
    { label: "Igual a", value: "equal" },
    { label: "Diferente de", value: "notEqual" }
  ];

  const graphTypes = {
    "line": "Gráfico de linea",
    "VBars": "Gráfico de barras vertical",
    "HBars": "Gráfico de barras horizontal"
  }

//colores
  const colorOptions = {
    "pastel": "Paleta pastel",
    "blue": "Paleta azul",
    "red": "Paleta roja",
    "fixed": "Color fijo"
  }

  //backend flags
  const [loading, setLoading] = useState(true);
  const [fetchingParameters, setFetchingParameters] = useState(true);
  const [creatingWidget, setCreatingWidget] = useState(false);
  const [fetchingWidgetInfo, setFetchingWidgetInfo] = useState(true);

  //obtener info existente del widget
  const refreshWidgetInfo = () => {
    async function fetchWigdet(){
      const widget = await getWidgetById(id, auth?.token);
      return widget; 
    }
    try {
      setFetchingWidgetInfo(true);
      fetchWigdet().then(response => {
        console.log(response.configuration)
        setConf(response.configuration)
        setSelectedProcess(response.configuration.process.id)
        setTimespan(response.configuration.timespan)
        setAggregation(response.configuration.aggregation)
        setIsRate(response.configuration.isRate || false)
        setInterval(response.configuration.interval)
        //setDataRange(response.configuration.dateRange.selectedRange === "byDashboard" ? "Asignar por dashboard": response.configuration.dateRange.selectedRange)
        setFetchingWidgetInfo(false);
        setTitle(response.title)
      }).catch(error => {
        if (error.response.status === 404){
          console.log("Widget no encontrado")
        }
        else if (error.response.status === 500){
          console.log("Error en el servidor, intente nuevamente")
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error,typeof(error));
      setFetchingWidgetInfo(false);
    }
  }
  
  const refreshParameters = () => {
    async function fetchParameters(){
      const parameters = await getAllParameters(selectedProcess, auth?.token);
      return parameters;
    }
    try {
      setFetchingParameters(true);
      fetchParameters().then(response => {
        console.log(console.log(response))
        setParameters(response.map(parameter => {
          return {
            key: parameter.key,
            alias: parameter.alias,
            type: parameter.datatype
          }
        }));
        setFetchingParameters(false);
      }).catch(error => {
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setFetchingParameters(false);
    }
  }

  const createWidgetDB = () => {
    async function fetchWidget(){
      const position= assignSpace();
      const widget = await createWidget({
        type: "processPlanning",
        title: title,
        description: "",
        configuration: conf,
        dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 200,
        height: 200,
        selectedTab
      }, auth?.token);
      
      return widget;
    }
    try {
      setCreatingWidget(true);
      fetchWidget().then(response => {
        console.log(console.log(response));
        addCard (
          response._id,
          response.title,
          response.type,
          response.dashboardId,
          
        )
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget "+ title + " creado exitosamente.",1)
      }).catch(error => {
        console.log(error)
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setCreatingWidget(false);
    }
  }

  const editWidgetDB = () => {
    async function saveWidget(){

      const widget = await updateWidget(id,{
        type: "processPlanning",
        title: title,
        description: "",
        configuration: conf,
        /* dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 200,
        height: 200, */
      }, auth?.token);
      
      return widget;
    }
    try {
      setCreatingWidget(true);
      saveWidget().then(response => {
        console.log(console.log(response));
        
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget "+ title + " editado exitosamente.",1);
      }).catch(error => {
        console.log(error)
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setCreatingWidget(false);
    }
  }

  const selectVariableToCompare = (selectedItems) => {
    if (parameters && selectedItems){
      const selectedToCompare = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.variableToCompare = selectedToCompare
      setConf({...tempConf})
    }
    
  }

  const selectGroupList = (selectedItems) => {
    if (parameters && selectedItems){
      const groupList = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.groupList = groupList
      setConf({...tempConf})
    }
  }

  const deleteToCompare = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.variableToCompare = undefined
      setConf({...tempConf})
    } 
  }

  const deleteGroupList = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.groupList = undefined
      setConf({...tempConf})
    } 
  }

  const selectFinishStatus = (selectedKey) => {
    const targetParam = parameters.find(
      (p) => p?.alias === selectedKey || p?.key === selectedKey
    );
    setConf((prev) => ({
      ...prev,
      finishStatus: {
        target: {
          key: targetParam?.key,
          alias: targetParam?.alias || targetParam?.key,
          type: targetParam?.type
        },
        where: undefined
      }
    }));
  };
  
  const deletePlanningId = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.planningId = undefined
      setConf({...tempConf})
    } 
  }

  const deleteFinishStatus = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.finishStatus = undefined
      setConf({...tempConf})
    } 
  }


  /* const selectPlannedValue = (selectedItems) => {
    if (parameters && selectedItems){
      const selectedValue = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.noConformValue = selectedValue
      setConf({...tempConf})
    }
  } */
  const selectPlanningId = (selectedItems) => {
    if (parameters && selectedItems){
      const selectedValue = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.planningId = selectedValue
      setConf({...tempConf})
    }
  }
  
  const deletePlannedValue = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.plannedValue = undefined
      setConf({...tempConf})
    } 
  }

  const handleChangeIsRate = (rate) => {
    setIsRate(rate);
    let tempConf = {...conf}
    tempConf.isRate = rate
    setConf({...tempConf})
  }

  const handleProcessChange = (selectedProcess) => {
    let tempConf = {...conf}
    tempConf.conformValue = undefined;
    tempConf.noConformValue = undefined;
    tempConf.process = {
      id: selectedProcess,
      name: processList[selectedProcess]
    }
    setConf({...tempConf})
  }
  const handleDataRangeChange = (selectedRange) => {
    setDataRange(translateDatePicker(selectedRange));
    let tempConf = {...conf}
    tempConf.dateRange = selectedRange
    setConf({...tempConf})
  }
  const handleDecimalsChange = (decimals) => {
    let tempConf = {...conf}
    tempConf.nDecimals = decimals
    setConf({...tempConf})
  }
  const handleHasInterval = (hasInterval) => {
    let tempConf = {...conf}
    tempConf.hasInterval = hasInterval
    setConf({...tempConf})
  }
  const handleGraphType = (graphType) => {
    let tempConf = {...conf}
    tempConf.graphType = graphType
    setConf({...tempConf})
  }
  
  const handleChangeWidgetName = (name) => {
    setTitle(name)
  }
  const handleChangeAggregation = (aggregation) => {
    let tempConf = {...conf}
    tempConf.aggregation = aggregation
    setConf({...tempConf})
  }
  const handleChangeInterval = (interval) => {
    let tempConf = {...conf}
    tempConf.interval = Number(interval)
    setConf({...tempConf})
  }
  const handleChangeTimespan = (timespan) => {
    let tempConf = {...conf}
    tempConf.timespan = timespan
    setConf({...tempConf})
  }
  const handleCreateWidget = () =>{
    createWidgetDB();
  }
  const handleEditWidget = () =>{
    editWidgetDB();
  }

  // Handlers para conformValue

  // Selección del campo objetivo
const handleSelectFinishStatusTarget = (selectedField) => {
  const param = parameters.find(el => el.alias === selectedField || el.key === selectedField);
  setConf(prev => ({
    ...prev,
    conformValue: {
      ...prev.finishStatus,
      target: param ? { key: param.key, alias: param.alias, type: param.type } : undefined
    }
  }));
};

// Selección del campo para el WHERE
  const handleSelectFinishStatusWhereField = (selectedField) => {
    const param = parameters.find(el => el.alias === selectedField || el.key === selectedField);
    setConf(prev => ({
      ...prev,
      finishStatus: {
        ...prev.finishStatus,
        where: param ? { [param.key]: {} } : undefined
      }
    }));
  };

  // Selección del operador (equal o notEqual)
  const handleSelectFinishStatusWhereOperator = (operator) => {
    setConf(prev => {
      if (!prev.finishStatus?.where) return prev;
      const field = Object.keys(prev.finishStatus.where)[0];
      return {
        ...prev,
        finishStatus: {
          ...prev.finishStatus,
          where: { [field]: { [operator]: "" } } // operador inicial vacío
        }
      };
    });
  };

  // Cambiar valor del where
  const handleSelectFinishStatusWhereValue = (value) => {
    setConf(prev => {
      if (!prev.finishStatus?.where) return prev;
      const field = Object.keys(prev.finishStatus.where)[0];
      const operator = Object.keys(prev.finishStatus.where[field])[0]; // equal o notEqual
      return {
        ...prev,
        finishStatus: {
          ...prev.finishStatus,
          where: { [field]: { [operator]: value } }
        }
      };
    });
  };


  const selectPlannedValue = (selectedKey) => {
    const targetParam = parameters.find(
      (p) => p?.alias === selectedKey || p?.key === selectedKey
    );
    setConf((prev) => ({
      ...prev,
      plannedValue: {
        target: {
          key: targetParam?.key,
          alias: targetParam?.alias || targetParam?.key,
          type: targetParam?.type
        },
        where: undefined
      }
    }));
  };

  const selectPlannedWhereField = (selectedKey) => {
    const fieldParam = parameters.find(
      (p) => p?.alias === selectedKey || p?.key === selectedKey
    );
    setConf((prev) => ({
      ...prev,
      plannedValue: {
        ...prev.plannedValue,
        where: { [fieldParam?.key]: { equal: "" } }
      }
    }));
  };

  const handleSelectPlannedValueWhereOperator = (operator) => {
    setConf((prev) => {
      const field = Object.keys(prev.plannedValue.where || {})[0];
      if (!field) return prev;
      return {
        ...prev,
        plannedValue: {
          ...prev.plannedValue,
          where: { [field]: { [operator]: "" } }
        }
      };
    });
  };

  const handleSelectPlannedValueWhereValue = (value) => {
    setConf((prev) => {
      const field = Object.keys(prev.plannedValue.where || {})[0];
      if (!field) return prev;
      const operator = Object.keys(prev.plannedValue.where[field] || {})[0];
      return {
        ...prev,
        plannedValue: {
          ...prev.plannedValue,
          where: { [field]: { [operator]: value } }
        }
      };
    });
  };

  //Interacciones con el dashboard
  const selectColums = (selectedItems) => {
    let tempConf = {...conf}
    console.log(tempConf, "antes")
    let newHeaders = parameters.filter( element => {return selectedItems.includes( element.alias || element.key)});
    newHeaders = newHeaders.map(header => {return {...header, displayName: header.alias || header.key, color: "bluesens", stacked: false}})
    tempConf.headers = newHeaders
    setConf(tempConf);
    
  }

  const changeColors = (color, index) => {
    let tempConf = {...conf}
    tempConf.headers[index].color = color
    setConf(tempConf);
    console.log(tempConf)
  }

  const selectColorPalette = (selectedColor) => {
    if (selectedColor){
      let tempConf = {...conf}
      tempConf.colorPalette = selectedColor
      setConf({...tempConf})
    }
  }
  const selectFixedColor = (selectedColor) => {
    if (selectedColor){
      let tempConf = {...conf}
      tempConf.fixedColor = selectedColor
      setConf({...tempConf})
    }
  }
  const selectTextColor = (selectedColor) => {
    if (selectedColor){
      let tempConf = {...conf}
      tempConf.textColor = selectedColor
      setConf({...tempConf})
    }
  }

  useEffect( () => {
    if (selectedProcess){
      //limpiar headers actuales
      //cargar los parametros
      refreshParameters();
      //actualizar la configuracion
      handleProcessChange(selectedProcess);

    }
  }, [selectedProcess]);
  useEffect( () => {
    const bdConf = {
      process: undefined,
      planningId: undefined,
      finishStatus: undefined,
      conformValue: undefined,
      noConformValue: undefined,
      groupList: undefined, 
      dateRange: {
        "activeTab": "customDates",
        "selectedRange": "byDashboard"
      },
      nDecimals: 2,
      isRate: false,
      dateFormat: "mm/dd/yy - hh:mm",
      aggregation: "add",
      timespan: "hours",
      hasIntervals: true,
      graphType : "line",
      interval: 1,
      colorPalette: "fixed",
      fixedColor: "#4287f5",
      textColor: "#000000"
    }

    setLoading(true);
    //cargar campos
    //cargar conf
    let processOptions = {}
    menuItems.slice(1).map(element => 
      processOptions[element.id] = element.label
    )
    console.log(processOptions);
    if(id) {
      refreshWidgetInfo()
    }
    else{
      setConf(bdConf);
      
    }
    setProcessList(processOptions);
    setLoading(false);
  }, []);
  useEffect( () => {
    if (stage === "form"){

    }
    if (stage === "columnSection"){

    }
  }, [])

  useEffect(() => {
    const basicFieldsValid =
      title !== "" &&
      conf?.process &&
      (conf?.headers.length != 0 ) &&
      conf?.planningId && 
      conf?.finishStatus && 
      conf?.variableToCompare &&
      conf?.dateRange &&
      conf?.nDecimals;

    // Si hasInterval es true, también validamos timespan e interval
    const intervalFieldsValid = conf?.hasInterval
      ? conf?.timespan && conf?.interval
      : true; // si no tiene intervalo, siempre true

    if (basicFieldsValid && intervalFieldsValid) {
      setValidate(true);
    } else {
      console.log(
        "title:", !title,
        "process:", !conf?.process,
        "planningId:", !conf?.planningId,
        "finishStatus:", !conf?.finishStatus,
        "variableToCompare:", !conf?.variableToCompare,
        "dateRange:", !conf?.dateRange,
        "nDecimals:", !conf?.nDecimals,
        "timespan:", !conf?.timespan,
        "interval:", !conf?.interval,
        "hasInterval:", conf?.hasInterval
      );
      console.log(conf);
      setValidate(false);
    }
  }, [conf, title]);


  useEffect( () => {
    if (id){
      refreshWidgetInfo()
    }
    setFetchingWidgetInfo(false)
    
  }, [id])

  return (
    <>
     {stage === "form" && (
      <>
        {conf && !fetchingWidgetInfo && (
            <div className='flex flex-col gap-2 h-[35rem] relative overflow-auto'>
              <div className=' flex flex-col flex-grow gap-2'>
                <CollapsableSection title={"Datos"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' open={true} border={false}>
                  <div className='flex flex-col gap-2'>
                    <div className='flex justify-between items-center w-[100%] mb-1.5'>
                      <SelectionForm
                        text="Proceso" 
                        options={Object.keys(processList)} 
                        mask={processList} 
                        value={selectedProcess}
                        onChange={event => setSelectedProcess(event)}
                        AppendClassName=' -mb-4'
                        error={!!selectedProcess && !fetchingParameters && parameters.length === 0 ? 'El proceso no tiene parametros creados' : ""}
                      /> 
                      <div className='flex w-full justify-end'>
                        
                      </div>
                    </div>
                    <CollapsableSection
                      title={"Identificador del plan"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        { conf.planningId && (
                          <ColumnField header={conf.planningId} onDelete={deletePlanningId}/>
                        )}
                        { !conf.planningId && (
                          <div className=' mx-auto'>
                            <ButtonForm 
                              text={"Agregar campo"} 
                              Icon={() => {return (<AddIco fill='white'/>)}} 
                              enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                              action={ () => setStage("setPlanningId")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>
                    <CollapsableSection
                      title={"Valor de planificación"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        { conf.plannedValue && (
                          <ComplexColumnField header={conf.plannedValue} onDelete={deletePlannedValue}/>
                        )}
                        { !conf.plannedValue && (
                          <div className=' mx-auto'>
                            <ButtonForm 
                              text={"Agregar campo"} 
                              Icon={() => {return (<AddIco fill='white'/>)}} 
                              enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                              action={ () => setStage("setPlannedValue")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>
                    <CollapsableSection
                      title={"Estado finalización"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        { conf.finishStatus && (
                          <ComplexColumnField header={conf.finishStatus} onDelete={deleteFinishStatus}/>
                        )}
                        { !conf.finishStatus && (
                          <div className=' mx-auto'>
                            <ButtonForm 
                              text={"Agregar campo"} 
                              Icon={() => {return (<AddIco fill='white'/>)}} 
                              enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                              action={ () => setStage("setFinishStatus")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>
                    <CollapsableSection 
                      title={"Variable de tiempo"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        { conf.variableToCompare && (
                          <ColumnField header={conf.variableToCompare} onDelete={deleteToCompare}/>
                        )}
                        { !conf.variableToCompare && (
                          <div className=' mx-auto'>
                            <ButtonForm 
                              text={"Agregar campo"} 
                              Icon={() => {return (<AddIco fill='white'/>)}} 
                              enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                              action={ () => setStage("setTimeValue")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>
                    <CollapsableSection
                      title={"Agrupar por"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        { conf.groupList && (
                          <ColumnField header={conf.groupList} onDelete={deleteGroupList}/>
                        )}
                        { !conf.groupList && (
                          <div className=' mx-auto'>
                            <ButtonForm 
                              text={"Agregar campo"} 
                              Icon={() => {return (<AddIco fill='white'/>)}} 
                              enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                              action={ () => setStage("setGroupList")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>
                    <CollapsableSection
                      title={"Columnas de tabla"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='relative flex justify-end items-center'>
                        <ButtonForm text={"Añadir columnas"} enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0} action={()=> setStage("columnSection")} loading={fetchingParameters && selectedProcess}/>
                      </div>
                      <div className='flex flex-col gap-2 mt-2'>
                        {
                          conf?.headers?.map((header, index) => (
                            <CollapsableSection
                              key={index}
                              CustomTitleBar={() => (
                                <ColumnRowField
                                  header={header}
                                  onChange={(color) => changeColors(color,index)}
                                  onDelete={() => {
                                    // eliminar columna
                                    const temp = [...conf.headers];
                                    temp.splice(index, 1);
                                    setConf({...conf, headers: temp});
                                  }}
                                />
                              )}
                              titleBgColor='bg-aliceblue'
                              titleTextColor='text-gray'
                            >
                              <div className='w-full flex flex-col px-4'>
                                <InputForm text={"Nombre de la columna"} value={header.displayName} />
                                <SelectionForm text="Color" options={["Asignar por widget"]} />
                              </div>
                            </CollapsableSection>
                          ))}
                      </div>
                      
                    </CollapsableSection>
                    
                    
                    <div className='-mb-4 pt-4'>
                      <InputForm 
                        type={"datarange"} 
                        text={"Rango de tiempo"} 
                        value={dataRange} 
                        AppendClassName='text-left' 
                        onChange={(event) => handleDataRangeChange(event)}
                        dateRangeOptions={conf.dateRange}
                        addedRanges={ {"byDashboard": () => {}}} 
                      />
                    </div>
                    
                  </div>
                </CollapsableSection>
                <CollapsableSection title={"Apariencia"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' border={false} open={true}>
                  <div className='-mb-4 '>
                    <InputForm text={"Nombre"} value={title} onChange={(event) => setTitle(event.target.value)}/>
                  </div>
                  <div className='-mb-4 pt-2'>
                    <InputForm type={"number"} text={"Decimales"} value={conf.nDecimals} onChange={(event) => handleDecimalsChange(event.target.value)}/>
                  </div>
                  
                  <div className='-mb-4 pt-2'>
                    <InputForm type={"button"} text={"Estilo"} value={"Modificar estilo"} AppendClassName='text-left' onClick={() => {setStage("setAparience")}}/>
                  </div>
                </CollapsableSection>
              </div>

            {/* Span fijo al final del contenedor */}
            <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
              <div className='flex w-full justify-end'>
                <button className='' onClick={() => id ? handleEditWidget() : handleCreateWidget()}  disabled={!validate}>
                  <CheckIco width='50px' height='50px' fill={validate ? 'bluesens': 'gray'}/>
                </button>
              </div>
            </div>
          </div>
        )}
        {(!conf || fetchingWidgetInfo) && (
          <Spinner />
        )}
      </>
      
      
     )}
     {stage === "setTimeValue" && (
      <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
        <div className=' flex flex-col flex-grow gap-2'>
          <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
          <SelectableList 
            items={parameters.filter(element => element.type === "date").map(element => element.alias ? element.alias : element.key)} 
            multiSelect={false} 
            setItems={selectVariableToCompare}/>
        </div>
        
        {/* Span fijo al final del contenedor */}
        <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
          <div className='flex w-full justify-end'>
            < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
     )}
     {stage === "setPlanningId" && (
        <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
          <div className=' flex flex-col flex-grow gap-2'>
            <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
            <SelectableList 
              items={parameters.filter(element => !element.type  ).map(element => element.alias ? element.alias : element.key)} 
              multiSelect={false} 
              setItems={selectPlanningId}
            />
          </div>
          
          {/* Span fijo al final del contenedor */}
          <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
            <div className='flex w-full justify-end'>
              < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
            </div>
          </div>
        </div>
      )}


     {stage === "setPlannedValue" && (
      <div className="flex flex-col gap-2 h-[25rem] relative overflow-auto ">
        <div className="flex flex-col flex-grow gap-2">
          <span className="font-semibold text-lg">{processList[selectedProcess]} - Valor de planificación</span>
          
          {/* Selección de campo target */}
          <DropdownSelectableList 
            items={parameters.filter(e => e.type === "numeric" || e.type === "time")
              .map(e => e.alias ? e.alias : e.key)}
            multiSelect={false}
            setItems={selectPlannedValue}
          />

          {/* Selección de campo where */}
          {conf.plannedValue?.target && (
            <div className="mt-4">
              <span className="font-medium">Condición sobre otro campo</span>
              <DropdownSelectableList 
                items={parameters.map(e => e.alias ? e.alias : e.key)}
                multiSelect={false}
                setItems={selectPlannedWhereField}
              />
            </div>
          )}

          {/* Operador + valor */}
          {conf.plannedValue?.where && (
            <div className="mt-2">
              <span className="font-medium">Operador</span>
              <select
                className="border px-2 py-1 rounded w-full"
                onChange={(e) => handleSelectPlannedValueWhereOperator(e.target.value)}
                value={(() => {
                  const field = Object.keys(conf.plannedValue.where || {})[0];
                  if (!field) return "";
                  return Object.keys(conf.plannedValue.where[field])[0];
                })()}
              >
                <option value="">Seleccione un operador</option>
                {OPERATOR_OPTIONS.map(op => (
                  <option key={op.value} value={op.value}>
                    {op.label}
                  </option>
                ))}
              </select>

              <input
                type="text"
                placeholder="Valor"
                className="border px-2 py-1 rounded w-full mt-2"
                onChange={(e) => handleSelectPlannedValueWhereValue(e.target.value)}
                value={(() => {
                  const field = Object.keys(conf.plannedValue.where || {})[0];
                  if (!field) return "";
                  const operator = Object.keys(conf.plannedValue.where[field])[0];
                  return conf.plannedValue.where[field][operator] || "";
                })()}
              />
            </div>
          )}
        </div>

        {/* Guardar */}
        <div className="flex-none sticky bottom-0 bg-white p-2 shadow-lg">
          <div className="flex w-full justify-end">
            <ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
    )}

    {stage === "setFinishStatus" && (
      <div className="flex flex-col gap-2 h-[25rem] relative overflow-auto ">
        <div className="flex flex-col flex-grow gap-2">
          <span className="font-semibold text-lg">{processList[selectedProcess]} - Estado Finalización</span>
          
          {/* Selección de campo target */}
          <DropdownSelectableList 
            items={parameters.filter(e => !e.type )
              .map(e => e.alias ? e.alias : e.key)}
            multiSelect={false}
            setItems={selectFinishStatus}
          />

          {/* Selección de campo where */}
          {conf.finishStatus?.target && (
            <div className="mt-4">
              <span className="font-medium">Condición sobre otro campo</span>
              <DropdownSelectableList 
                items={parameters.map(e => e.alias ? e.alias : e.key)}
                multiSelect={false}
                setItems={handleSelectFinishStatusWhereField}
              />
            </div>
          )}

          {/* Operador + valor */}
          {conf.finishStatus?.where && (
            <div className="mt-2">
              <span className="font-medium">Operador</span>
              <select
                className="border px-2 py-1 rounded w-full"
                onChange={(e) => handleSelectFinishStatusWhereOperator(e.target.value)}
                value={(() => {
                  const field = Object.keys(conf.finishStatus.where || {})[0];
                  if (!field) return "";
                  return Object.keys(conf.finishStatus.where[field])[0];
                })()}
              >
                <option value="">Seleccione un operador</option>
                {OPERATOR_OPTIONS.map(op => (
                  <option key={op.value} value={op.value}>
                    {op.label}
                  </option>
                ))}
              </select>

              <input
                type="text"
                placeholder="Valor"
                className="border px-2 py-1 rounded w-full mt-2"
                onChange={(e) => handleSelectFinishStatusWhereValue(e.target.value)}
                value={(() => {
                  const field = Object.keys(conf.finishStatus.where || {})[0];
                  if (!field) return "";
                  const operator = Object.keys(conf.finishStatus.where[field])[0];
                  return conf.finishStatus.where[field][operator] || "";
                })()}
              />
            </div>
          )}
        </div>

        {/* Guardar */}
        <div className="flex-none sticky bottom-0 bg-white p-2 shadow-lg">
          <div className="flex w-full justify-end">
            <ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
    )}


      {stage === "setGroupList" && (
      <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
        <div className=' flex flex-col flex-grow gap-2'>
          <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
          <SelectableList 
            items={parameters.filter(element => !element.type  ).map(element => element.alias ? element.alias : element.key)} 
            multiSelect={false} 
            setItems={selectGroupList}
          />
        </div>
        
        {/* Span fijo al final del contenedor */}
        <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
          <div className='flex w-full justify-end'>
            < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
     )}

     {stage === "columnSection" && (
      <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
        <div className=' flex flex-col flex-grow gap-2'>
          <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
          <SelectableList 
            items={parameters?.map(element => element.alias ? element.alias : element.key)} 
            multiSelect={true} 
            setItems={selectColums}
            selection={conf?.headers?.map(element => element.alias ? element.alias : element.key)}
            />
        </div>
        
        {/* Span fijo al final del contenedor */}
        <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
          <div className='flex w-full justify-end'>
              < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
     )}

     {/* Apariencia */} 
      {stage === "setAparience" && (
        <div className="flex flex-col gap-2 h-[25rem] relative overflow-auto">
          <div className="flex flex-col flex-grow gap-2">
            <span className="font-semibold text-lg">Modificar estilo</span>

            {/* Selección de paleta de colores */}
            <SelectionForm
              id="colorPalette"
              text="Paleta de colores"
              options={Object.keys(colorOptions)}
              mask={colorOptions}
              value={conf?.colorPalette || "pastel"}
              onChange={(event) => selectColorPalette(event)}
            />

            {/* Mostrar el color fijo solo si se selecciona esa opción */}
            {conf?.colorPalette === "fixed" && (
              <InputForm
                id="fixedColor"
                type="color"
                text="Seleccionar color fijo"
                value={conf?.fixedColor || "#4287f5"}
                onChange={(event) => selectFixedColor(event)}
              />
            )}
            <InputForm
              id="textColor"
              type="color"
              text="Seleccionar color del texto"
              value={conf?.textColor || "#000000"}
              onChange={(event) => selectTextColor(event)}
            />
          </div>

          {/* Botón fijo al final */}
          <div className="flex-none sticky bottom-0 bg-white p-2 shadow-lg">
            <div className="flex w-full justify-end">
              <ButtonForm
                text={"Guardar"}
                enabled={true}
                action={() => setStage("form")}
              />
            </div>
          </div>
        </div>
      )}
    </>
   
    
  );
}

export default PlanningTableForm;
